<template>
    <div class="animated fadeIn">
                <div class="row mb-4" v-if="applicant">
                     <h5 class="mb-3 col-sm-12">{{$t('APPLICANT')}}:</h5>

                    <div class="col-md-4">
                        <div><b>{{$t('FIRST_NAME')}}: </b>{{applicant.first_name}}</div>
                        <div><b>{{$t('LAST_NAME')}}: </b>{{applicant.last_name}}</div>
                        <div><b>{{$t('DATE_OF_BIRTH')}}: </b>{{formatDate(applicant.date_of_birth)}}</div>
                    </div>
                    <div class="col-md-4">
                        <div><b>{{$t('GENDER')}}: </b>{{applicant.gender}}</div>
                        <div><b>{{$t('CONTACT')}}: </b>{{applicant.contact}}</div>
                        <div><b>{{$t('NATIONALITY')}}:</b>{{applicant.nationality}}</div>
                    </div>
                    <div class="vl ml-auto d-none d-md-block pl-4"></div>
                    <div class="col-md-3">
                        <div>{{$t('RECORD_WAS_CREATED')}}: <span v-if="applicant.hasOwnProperty('insert_user.first_name')">{{applicant.insert_user.first_name}}</span></div>
                        <div>{{$t('DATE_CREATION')}}: {{formatDate(applicant.created_at)}}</div>
                        <div v-if="applicant.hasOwnProperty('update_user.first_name')">{{$t('LAST_MODIFIED')}}: {{applicant.update_user.first_name}}</div>
                        <div>{{$t('LAST_CHANGE')}}: {{formatDate(applicant.updated_at)}}</div>
                    </div>
                </div>
                <hr size="30">
        <b-row v-if="recognition">
            <div class="row mb-4">
                <h5 class="mb-3 col-sm-12">{{$t('DATA_ON_RECOGNITION')}}:</h5>
                <div class="col-md-4">
                    <div><b>{{$t('PROTOCOL_NUMBER')}}: </b>{{recognition.request_protocol_number}}</div>
                    <div><b>{{$t('ORIGINAL_NAME_THE_SUPPORTING_DOCUMENTATION_MORE')}}: </b>{{recognition.original_name_accompanying_public_document}}</div>
                    <div><b>{{$t('EQF_LEVEL')}}: </b>{{recognition.eqf_level}}</div>
                    <div><b>{{$t('NAME_OF_FOREIGN_STUDY_PROGRAM')}}: </b>{{recognition.name_of_study_program_country_origin}}</div>
                </div>
                <div class="col-md-4">
                    <div><b>{{$t('DATE_OF_APPLICATION')}}: </b>{{formatDate(recognition.date_receipt_request)}}</div>
                    <div><b>{{$t('SCIENTIFIC_AREA')}}: </b> <span v-if="recognition.hasOwnProperty('qualification_area.name')">{{recognition.qualification_area.name}}</span></div>
                    <div><b>{{$t('LEVEL_OF_QUALIFICATION_IN_COUNTRY_RECOGNITION')}}: </b>{{recognition.nqf}}</div>
                    <div><b>{{$t('CREDIT_POINTS_COUNTRY_ORIGIN')}}: </b>{{recognition.load_of_study_program}}</div>
                </div>
                <div class="col-md-4">
                    <div><b>{{$t('ORIGINAL_TITLE_OF_HIGHER_QUALIFICATION')}}: </b>{{recognition.name_of_foreign_qualification}}</div>
                    <div><b>{{$t('LEVEL_OF_QUALIFICATION_ORIGIN_COUNTRY')}}: </b>{{recognition.level_qualification_country_origin}}</div>
                    <div><b>{{$t('CONDITIONS_FOR_ENTRY')}}: </b>{{recognition.enrollment_requirements}}</div>
                    <div><b>{{$t('ECTS')}}: </b>{{recognition.ects}}</div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md-4">
                    <div><b>{{$t('LENGTH_OF_STUDY')}}: </b>{{recognition.length_of_study}}</div>
                    <div><b>{{$t('CITY_OF_INSTITUTION')}}: </b>{{recognition.institution_town}}</div>
                    <div><b>{{$t('QUALIFICATION_AWARDING_DATE')}}: </b>{{formatDate(recognition.qualification_awarding_date)}}</div>
                </div>
                <div class="col-md-4">
                    <div><b>{{$t('ORIGIN_INSTITUTION')}}: </b>{{recognition.name_awarding_institution_original_lang}}</div>
                    <div><b>{{$t('ACCREDITATION_STATUS')}}: </b>{{recognition.accreditation_status}}</div>
                </div>
                <div class="col-md-4">
                    <div><b>{{$t('COUNTRY')}}: </b><span v-if="recognition.hasOwnProperty('country.name')">{{recognition.country.name}}</span></div>
                    <div><b>{{$t('ACCREDITED_STUDY_PROGRAM')}}: </b>{{recognition.accredited_study_program}}</div>
                    <div><b>{{$t('DEGREE_NUMBER_THE_COUNTRY_OF_ORIGIN')}}: </b>{{recognition.document_number}}</div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md-4">
                    <p><b>{{$t('COMPETENT_RECOGNITION_AUTHORITY')}}: </b>{{recognition.decision_recognition}}</p>
                    <p><b>{{$t('DECISION_PROTOCOL_NUMBER')}}: </b>{{recognition.decision_protocol_number}}</p>
                    <p><b>{{$t('RECOGNITION_DATE')}}: </b>{{formatDate(recognition.recognition_date)}}</p>
                </div>
                <div class="col-md-4">
                    <div><b>{{$t('DESCRIPTION_DECISION')}}: </b>{{recognition.description_decision}}</div>
                </div>
                <div class="vl ml-auto d-none d-md-block pl-4"></div>
                <div class="col-sm-5 col-md-3">
                    <div>{{$t('RECORD_WAS_CREATED')}}: <span v-if="recognition.hasOwnProperty('insert_user.first_name')">{{recognition.insert_user.first_name}}</span></div>
                    <div>{{$t('DATE_CREATION')}}: {{formatDate(recognition.created_at)}}</div>
                    <div>{{$t('LAST_MODIFIED')}}: <span v-if="recognition.hasOwnProperty('update_user.first_name')">{{recognition.update_user.first_name}}</span></div>
                    <div>{{$t('LAST_CHANGE')}}: {{formatDate(recognition.updated_at)}}</div>
                </div>
            </div>
        </b-row>
              <b-row>
                <b-col>
                    <app-button :c_permission="C_APPLICANT_RECOGNITION_PDF_BUTTON"
                                @click="getPdf"
                                class="pull-right" variant="danger">PDF
                    </app-button>
                </b-col>
              </b-row>
             </div>
</template>

<script>
 import {getApplicant, generatePdfDecision} from "@/services/applicant"
 import {getRecognition} from '@/services/recognition/index'
 import moment from 'moment'
 import AppButton from "@/components/app/AppButton"
 import {C_APPLICANT_RECOGNITION_PDF_BUTTON} from "@/shared/component_permission"
export default {
  components: {AppButton},
  data() {
       return {
           applicant:{},
           recognition:{},
           C_APPLICANT_RECOGNITION_PDF_BUTTON
        }
   },
  computed:{
    linkToPdf(){
      if(this.recognition.hasOwnProperty('id')){
        return this.getPdf()
      }
      return null
    }
  },
   methods: {
       getApp() {
           getApplicant(this.$route.params.id)
           .then(response => {
             this.applicant = response.data
           })
       },
     getPdf(){
       generatePdfDecision(this.$route.params.id).then(response => {

       })
     },
       getRec() {
           getRecognition(this.$route.params.id)
           .then(response => {
               this.recognition = response.data
           })
       },
       formatDate(value){
          if(value){
            const momentDate = new moment(value)
            return momentDate.format('DD.MM.YYYY')
          } else {
              return null
          }
      },
   },
   created() {
       this.getApp(),
       this.getRec()
   }
}
</script>

<style scoped>
.vl {
  border-left: 1px solid #b7b7b7;
  height: 100px;
}
</style>
